module.exports = __webpack_public_path__ + "img/fi-rr-bell-school.5ea7933f.svg";